export const COLOR_CODES = ['green300', 'green100', 'red200', 'red100', 'gold100',
  'gold200', 'black100', 'white'];

export default {
  COLOR_CODES,
};
